import { useState } from "react";
import { Expand } from "lucide-react";
import { useLang } from "@/lib/i18n";
import Lightbox from "@/components/Lightbox";
import Img from "@/components/Img";

export default function SectorGallery({ sectorId, items }) {
  const { t, L } = useLang();
  const [index, setIndex] = useState(null);
  if (!items?.length) return null;

  return (
    <div className="mt-10" data-testid={`sector-gallery-${sectorId}`}>
      <p className="eyebrow mb-4">{t("sectors_gallery")}</p>
      <div className={`grid grid-cols-2 gap-3 ${items.length % 4 === 0 ? "lg:grid-cols-4" : "sm:grid-cols-3"}`}>
        {items.map((g, i) => (
          <button
            key={i}
            type="button"
            data-testid={`gallery-thumb-${sectorId}-${i}`}
            onClick={() => setIndex(i)}
            className="group relative aspect-[4/3] overflow-hidden border border-border"
            style={{ borderRadius: "var(--radius)" }}
          >
            <Img
              src={g.image}
              width={640}
              sizes="(max-width: 640px) 50vw, 320px"
              alt={L(g.caption)}
              className="h-full w-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-110"
            />
            <span className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/10 to-transparent opacity-70 transition-opacity duration-300 group-hover:opacity-100" />
            <span className="absolute bottom-3 start-3 end-9 text-start text-[11px] leading-snug text-white/90">
              {L(g.caption)}
            </span>
            <span className="absolute top-3 end-3 flex h-7 w-7 items-center justify-center rounded-full border border-white/30 text-white opacity-0 transition-opacity duration-300 group-hover:opacity-100">
              <Expand className="h-3 w-3" />
            </span>
          </button>
        ))}
      </div>
      <Lightbox items={items} index={index} onClose={() => setIndex(null)} onIndexChange={setIndex} />
    </div>
  );
}
